import React, { useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../api";
import { useAuth } from "../auth/AuthContext";

function useQuery() { return new URLSearchParams(useLocation().search); }

export default function VerifyEmail() {
  const q = useQuery();
  const email = q.get("email") || "";
  const purpose = q.get("purpose") || "signup";
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();

  const endpoint = useMemo(() => purpose === "reset" ? "/api/auth/forgot/verify" : "/api/auth/signup/verify", [purpose]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      if (purpose === "reset") {
        // not used here (ResetPassword page handles reset)
        return;
      }
      const { data } = await api.post(endpoint, { email, otp });
      loginWithToken(data.token, data.user);
      navigate("/");
    } catch (e) {
      alert(e?.response?.data?.error || "Verification failed");
    } finally {
      setLoading(false);
    }
  };

  const panelImg = (process.env.PUBLIC_URL || "") + "/court8.jpg";
  const pageBg = (process.env.PUBLIC_URL || "") + "/court7.jpg";

  return (
    <div
      className="relative min-h-screen flex items-center justify-center p-4 bg-[var(--bg)] text-[var(--fg)]"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(59,130,246,0.08), rgba(16,185,129,0.08)), url(${pageBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-[var(--bg)]/85 backdrop-blur-sm" />

      <div className="relative z-10 w-full max-w-md md:max-w-lg grid grid-cols-1 md:[grid-template-columns:38%_62%] rounded-2xl overflow-hidden surface-card">
        <div className="relative hidden md:block md:min-h-[420px]">
          <img src={panelImg} alt="State emblem & gavel" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 to-black/10" />
          <div className="absolute bottom-3 left-3 right-3 bg-white/80 backdrop-blur px-3 py-1.5 rounded-md text-[11px] text-slate-700 shadow">
            Secure access · New York Courts
          </div>
        </div>

        <div className="p-6 bg-[var(--surface)]">
          <p className="page-kicker">Verification</p>
          <h1 className="page-title">Verify your email</h1>
          <p className="page-subtitle mb-4">We sent a 6-digit code to <b>{email}</b></p>

          <form onSubmit={submit} className="space-y-3">
            <div>
              <label className="block text-xs font-medium text-[var(--fg)] mb-1">Verification code</label>
              <input
                className="w-full ui-input"
                placeholder="Enter 6-digit code"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
              />
            </div>
            <button disabled={loading} className="w-full ui-btn ui-btn-primary">
              {loading ? "..." : "Verify"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
